import { HTMLAttributes } from "react"

import { classNames } from "../../../../lib/classNames"

export type TableScrollContainerProps = HTMLAttributes<HTMLDivElement>

export function TableScrollContainer({
  className,
  ...otherProps
}: TableScrollContainerProps) {
  return (
    <div
      className={classNames(
        "relative",
        "w-full max-w-full overflow-x-auto",
        "h-full max-h-full min-h-0 shrink grow basis-0 overflow-y-auto",
        "bg-neutral-default",
        "border-v2-border-default border",
        className
      )}
      {...otherProps}
    />
  )
}
